/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC } from "react";
import { Box, Button, Stack, styled } from "@mui/material";
import { Const } from "const";
import { footerHeight } from "components/TaskRegisterMultipleCharge/consts";
import { useClickHandler } from "hooks/ClickHandleHook";

interface TaskRegisterPanelFooterProps {
  leftLabel: string;
  leftHandle: () => void;
  rightLabel?: string;
  rightHandle?: () => void;
  disabled: boolean;
}

export const TaskRegisterPanelFooter: FC<TaskRegisterPanelFooterProps> = ({
  leftLabel,
  leftHandle,
  rightLabel,
  rightHandle,
  disabled,
}) => {
  const leftClickHandler = useClickHandler(leftHandle);
  const rightClickHandler = useClickHandler(rightHandle);
  return (
    <FooterArea>
      <Stack direction={"row"} gap={2}>
        <Button
          variant="outlined"
          onClick={leftClickHandler}
          color="inherit"
          fullWidth
        >
          {leftLabel}
        </Button>
        {rightLabel !== undefined && (
          <Button
            variant="outlined"
            disabled={disabled}
            onClick={rightClickHandler}
            color="inherit"
            fullWidth
          >
            {rightLabel}
          </Button>
        )}
      </Stack>
    </FooterArea>
  );
};

const FooterArea = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(1, 2),
  height: footerHeight,
  backgroundColor: Const.sidePanelFooterColor,
  justifyContent: "center",
  alignItems: "center",
}));
